export const trimAddress = (addr) => {
  return `${addr.substring(0, 6) }...${addr.substring(addr.length - 4)}`;
}

export const contract = {
  1 : {
    MULTICALL_ADDRESS : "0x5BA1e12693Dc8F9c48aAD8770482f4739bEeD696",
    NFT_ADDRESS : "0x72d8ADa85641D3A696257A2ec8504Bf091a50EFE"
  }
}

export const DEFAULT_CHAIN = 1;

